import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

import { connect } from 'react-redux';
import { ModalDialog } from 'ecs-react-components/dist/index.es';
import { messages } from './Questionnaires.i18n';
import { questionnaireSelected } from '../../redux/modules/questionnaires/questionnaires-action-creator';
import { declineQuestionnaire } from '../../redux/modules/questionnaires/questionnaires-middleware';
import history from '../../history';

class NewQuestionnaireButton extends React.Component {
  constructor() {
    super();
    this.state = {
      isDeclineModalVisible: false,
    };
  }

  onStartButtonClick = () => {
    this.props.dispatch(questionnaireSelected(this.props.assignedQuestionnaireId));
    history.push(this.props.completeQuestionnairePage);
  };

  submitDeclineModal = () => {
    const { dispatch, patientId, assignedQuestionnaireId, questionnairesOrigin } = this.props;
    dispatch(declineQuestionnaire(patientId, assignedQuestionnaireId));
    this.hideDeclineModal();
    history.push(questionnairesOrigin);
  };

  hideDeclineModal = () => {
    this.setState({
      isDeclineModalVisible: false,
    });
  };

  showDeclineModal = () => {
    this.setState({
      isDeclineModalVisible: true,
    });
  };

  render() {
    const startButtonId = 'start_questionnaire_button_' + this.props.assignedQuestionnaireId;
    const declineButtonId = 'decline_questionnaire_button_' + this.props.assignedQuestionnaireId;
    return (
      <div className="utility-buttons">
        <p>
          <Button
            variant="primary"
            onClick={ this.onStartButtonClick }
            data-qa-item={ startButtonId }
            className="mb-0"
          >
            <i className="fa-regular fa-circle-play me-1"></i>
            <FormattedMessage { ...messages.button.startNow } />
          </Button>
        </p>
        {
          !this.props.hideDecline ?
            (
              <p>
                <button type="button"
                  className="btn btn-link float-end"
                  onClick={ this.showDeclineModal }
                  data-qa-item={ declineButtonId }
                >
                <FormattedMessage { ...messages.button.decline } />
                </button>
              </p>
            ) :
            null
        }
        <ModalDialog show={this.state.isDeclineModalVisible}
          title={messages.declineModal.title}
          message={messages.declineModal.message }
          submitBtnText={ messages.declineModal.submitBtnText }
          hideBtnText={messages.declineModal.hideBtnText}
          onSubmit={this.submitDeclineModal}
          onHide={this.hideDeclineModal}
          id={ this.props.assignedQuestionnaireId }
        />
      </div>
    );
  }
}

NewQuestionnaireButton.propTypes = {
  dispatch: PropTypes.func,
  assignedQuestionnaireId: PropTypes.string,
  patientId: PropTypes.string,
  hideDecline: PropTypes.bool,
  questionnairesOrigin: PropTypes.string,
  completeQuestionnairePage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  patientId: state.profile.patient.patientId,
  questionnairesOrigin: state.questionnaires.questionnairesOrigin,
  completeQuestionnairePage: state.questionnaires.completeQuestionnairePage,
});

export default connect(mapStateToProps)(NewQuestionnaireButton);